import { Dictionary, keyBy } from 'lodash';
import { useMemo } from 'react';
import { Team, User } from 'api/models';
import { CommonManagerProps } from 'components/organisms/resource-management/managers';
import { ViewPresetId } from 'components/organisms/resource-management/scheduler-config/view-presets/constants';
import {
  GroupBy,
  ProjectsWithMembers,
  SchedulerReference,
} from 'components/organisms/resource-management/types';
import { WorkingDaysConfiguration } from 'components/organisms/user-capacity';
import { useVendorRolesQuery } from 'queries/roles';

interface Props {
  workingDaysConfig: WorkingDaysConfiguration;
  project: ProjectsWithMembers;
  schedulerRef: SchedulerReference;
  userLookup: Dictionary<User>;
  teamLookup: Dictionary<Team>;
  teamMembership: Record<string, Team[]>;
}
export const useCommonManagerProps = ({
  workingDaysConfig,
  project,
  schedulerRef,
  teamLookup,
  userLookup,
  teamMembership,
}: Props): CommonManagerProps => {
  const { data: roles } = useVendorRolesQuery();

  return useMemo(
    () => ({
      groupBy: GroupBy.Projects,
      users: Object.values(userLookup),
      teams: Object.values(teamLookup),
      projects: [project],
      roleLookup: keyBy(roles, 'roleId'),
      userLookup,
      teamLookup,
      projectLookup: { [project.projectId]: project },
      workingDaysConfig,
      schedulerRef,
      rawUserAllocationSummary: {},
      setRawUserAllocationSummary: () => {},
      rawTeamAllocationSummary: {},
      setRawTeamAllocationSummary: () => {},
      excludeNonWorkingDays: true,
      currentViewPreset: ViewPresetId.Day, // Setting it to day by default for templates, is this ok ?
      teamMembership,
    }),
    [
      userLookup,
      teamLookup,
      project,
      roles,
      workingDaysConfig,
      schedulerRef,
      teamMembership,
    ],
  );
};
